import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SidebarState {
  isLocked: boolean;
  isHovered: boolean;
  isMobileOpen: boolean;
  toggleLock: () => void;
  setLocked: (locked: boolean) => void;
  toggleLocked: () => void;
  setHovered: (hovered: boolean) => void;
  setMobileOpen: (open: boolean) => void;
  toggleMobile: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      isLocked: true,
      isHovered: false,
      isMobileOpen: false,
      toggleLock: () => set((state) => ({ isLocked: !state.isLocked })),
      setLocked: (locked: boolean) => set({ isLocked: locked }),
      toggleLocked: () => set((state) => ({ isLocked: !state.isLocked })),
      setHovered: (hovered: boolean) => set({ isHovered: hovered }),
      setMobileOpen: (open: boolean) => set({ isMobileOpen: open }),
      toggleMobile: () => set((state) => ({ isMobileOpen: !state.isMobileOpen })),
    }),
    {
      name: 'chatagent_sidebar_state',
      partialize: (state) => ({ isLocked: state.isLocked }),
    }
  )
);

export const sidebarStore = useSidebarStore;
